import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { notifications } from '@/lib/api'

export const notificationKeys = {
  all: ['notifications'] as const,
  list: (params: object | undefined) => ['notifications', 'list', params ?? null] as const,
  unreadCount: ['notifications', 'unread-count'] as const,
}

export function useNotificationsList(params?: {
  only_unread?: boolean
  page?: number
  page_size?: number
}) {
  return useQuery({
    queryKey: notificationKeys.list(params),
    queryFn: async () => (await notifications.list(params)).data,
  })
}

export function useUnreadCount() {
  return useQuery({
    queryKey: notificationKeys.unreadCount,
    queryFn: async () => (await notifications.unreadCount()).data,
    refetchInterval: 30_000,
  })
}

export function useMarkRead() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id: number) => (await notifications.markRead(id)).data,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: notificationKeys.all })
    },
  })
}

export function useMarkAllRead() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async () => (await notifications.markAllRead()).data,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: notificationKeys.all })
    },
  })
}
